// src/gatsby-theme-docz/wrapper.js
import React from "react";
import "./customStyle.css";

export default ({ children }) => <div>{children}</div>;
